import { render, staticRenderFns } from "./PersonsEditPanelDialog.vue?vue&type=template&id=35fba6d8"
import script from "./PersonsEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./PersonsEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports